export enum TabPath {
    Overview = "overview",
    ConversationThemes = "conversation-themes",
    Insights = "insights",
    ImpactAnalysis = "impact-analysis",
}

export interface ClientAnalyticsTabConfig {
    overview_enabled: boolean;
    overview_date_filters_enabled: boolean;
    overview_cumulative_users_chart_enabled: boolean;
    overview_k_anonymization_enabled: boolean;
    conversation_themes_enabled: boolean;
    conversation_themes_examples_enabled: boolean;
    conversation_themes_date_filters_enabled: boolean;
    conversation_themes_k_anonymization_enabled: boolean;
    impact_analysis_enabled: boolean;
    insights_attrition_enabled: boolean;
    insights_productivity_enabled: boolean;
    users_export_enabled: boolean;
}

export type UsageDataResponse = {
    config: {
        grouping: "day" | "month";
        start_date: string;
        end_date: string;
        organization_id: string;
    };
    totals: {
        active_users: number;
        return_users: number;
        conversations: number;
    };
    counts: Array<{
        date: string;
        active_users: number;
        return_users: number;
        conversations: number;
    }>;
};

export type NadiaInsightResponse = {
    tab: string;
    content: string;
};

export enum FeedbackStatColor {
    Green = "green",
    Blue = "blue",
    Yellow = "yellow",
}

export interface FeedbackStat {
    title: string;
    value: string | number;
    caption: string;
    color?: FeedbackStatColor;
}

export interface FeedbackStatsResponse {
    stats: FeedbackStat[];
}

export interface FeedbackQuote {
    quote: string;
}

export interface FeedbackQuotesResponse {
    quotes: FeedbackQuote[];
}

export type UsersChartData = {
    error?: string;
    totals?: {
        registered_users: number;
        active_users: number;
        return_users: number;
    };
    monthly_counts: Array<{
        date: string;
        registered_users: number;
        active_users: number;
    }>;
    daily_cumulative_counts: Array<{
        date: string;
        registered_users: number;
        active_users: number;
        return_users: number;
    }>;
};

export type SessionsChartData = {
    error?: string;
    totals: {
        total_sessions: number;
    };
    counts: Array<{
        date: string;
        cumulative_sessions: number;
    }>;
};
export interface ConversationTheme {
    theme: string;
    percentage: number;
    sub_themes?: ConversationTheme[];
    description?: string;
    examples?: string[];
}

export interface ConversationThemesResponse {
    themes: ConversationTheme[];
}

export interface DateFilters {
    startDate: string | null;
    endDate: string | null;
}

export interface SSOFilterConfig {
    filter_key: string;
    label: string;
    icon: string;
    options: Array<{
        key: string | null;
        label: string;
    }>;
}

export type SelectedSSOFilters = Record<string, Array<string | null>>;
export type SelectedFilters = Record<string, Array<string | null> | string | null>;

export interface SSOFilterConfigResponse {
    filters: Array<SSOFilterConfig>;
}

export interface DriversOverTimeResponse {
    error?: string;
    drivers: Array<{
        label: string;
        user_percentage: number;
        history: Array<{
            date: string;
            user_count: number;
            user_percentage: number;
        }>;
    }>;
}

export interface ImpactResponse {
    total: number;
    history: Array<{
        date: string;
        count: number;
    }>;
}
